import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Pagination } from '../../modules/clientModule/components/Common/Table/types';
import PaginationMobile from '../Responsive/PaginationMobile';
import { useGetInspectionDocumentFileResubmitFlagQuery, useGetVocabularyQuery, useResubmitDocumentFileMutation } from '../../redux/rtkQuery/apiSlice';
import { RootState } from '../../redux/root';
import { CustomParams } from '../../modules/clientModule/types';
import { downloadSinglePermitDocumentWithFullName } from '../../api/projectDocuments';

const DocumentsDetailsFileList = ({ row, inspectorGetPermitDocuments }) => {
  if (!row) return <div>No row data available</div>;

  const [params, setParams] = useState<any>(null);
  const [params1, setParams1] = useState<any>(null);
  const [resubmitDocument] = useResubmitDocumentFileMutation();
  const { data: checkboxValues, refetch, isUninitialized } = useGetInspectionDocumentFileResubmitFlagQuery(params1, { skip: params1 === null });
  const { pageCount, pageIndex, pageSize } = useSelector((s: RootState) => s.pagination);
  const info = useSelector((s:RootState) => s.userAuth.info);
  const filters = useSelector((s: RootState) => s.filters.filters);
  const [rows, setRows] = useState([]);
  const [checks, setChecks] = useState({});

  const load = async () => {
    const res = await inspectorGetPermitDocuments({ limit: 100, offset: 0 });
    setRows(res.data.results);
  };
  useEffect(() => {
    load();
  }, []);
  const _params: CustomParams = {
    is_deleted: false,
    limit: pageSize,
    offset: pageIndex * pageSize,
    permit_id: row.permitId,
    event_type: 'Activity',
    activity_type_name: 'Document',
  };

  useEffect(() => {
    if (info) {
      setParams1({
        inspector: info.id,
        review_activity: row.id,
      });
      if (!isUninitialized) {
        refetch();
      }
    }
    if (checkboxValues && checkboxValues.length > 0) {
      const _checks = {};
      checkboxValues.forEach(r => {
        _checks[r.document] = r.resubmit;
      });
      setChecks(_checks);
    }
  }, [info, checkboxValues]);
  useEffect(() => {
    if (!row) return;

    const _params1: any = { ..._params, limit: pageSize };
    if (filters) {
      filters.forEach(f => {
        _params1[f.filterName] = f.filterValue;
      });
    }

    setParams(_params1);
  }, [pageSize, pageIndex, pageCount, filters, row]);

  const onChange = async (e, _row) => {
    const isChecked = e.target.checked;
    const _checks = { ...checks };
    _checks[_row.pk] = isChecked;
    setChecks(_checks);
    const payload = {
      inspector: info.id,
      review_activity: row.id,
      document: _row.pk,
      status: isChecked,
    };
    await resubmitDocument(payload);
  };

  const onLinkClick = async data => {
    let fileData = null;
    let documentPk = null;
    for (let i = 0; i < row.selectedDocuments.length; i++) {
      const document = row.selectedDocuments[i];
      if (!Array.isArray(document.clientFiles) || document.clientFiles.length === 0) {
        continue;
      }
      // Matched on id, not on the file URL. The two sides come from two
      // separate fetches, and most rows in this column store an absolute S3
      // URL as their filename -- comparing those strings is fragile, and the
      // id is what actually identifies the file.
      fileData = document.clientFiles.find(f => f.id === data.fileId);

      if (fileData) {
        documentPk = document.pk;
        break;
      }
    }
    const _data = {
      apiId: 'client_file_id',
      fileId: fileData.id,
      documentPk,
    };

    const res = await downloadSinglePermitDocumentWithFullName(_data);
    const base64 = res.data.file;
    const newTab = window.open("");
    newTab.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${base64}"></iframe>`);
  };
  return (
    <div>
      <>
        <GridBase>
          <HeaderCell>Document Name</HeaderCell>
          <HeaderCell>File</HeaderCell>
          <HeaderCell>Resubmit</HeaderCell>
        </GridBase>

        <Rows>
          {rows.map((row, index) => {
            return (
              <RowBase key={index}>
                <TableCell>
                  <FlexCol>{row.name}</FlexCol>
                </TableCell>
                <TableCell>
                  <FlexCol>
                    {row.clientFilesDetails &&
                      row.clientFilesDetails.map((file, index) => {
                        return <UrlLink onClick={e => onLinkClick(file)}>{file.fileName}</UrlLink>;
                      })}
                  </FlexCol>
                </TableCell>
                <TableCell>
                  <Center>
                    <input type="checkbox" onChange={e => onChange(e, row)} checked={checks[row.pk]} />
                  </Center>
                </TableCell>
              </RowBase>
            );
          })}
        </Rows>
      </>

      <Pagination>
        <PaginationMobile showEverywhere />
      </Pagination>
    </div>
  );
};

export default DocumentsDetailsFileList;

const GridBase = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr) 90px;
  width: 100%;
  text-align: left;
`;

const UrlLink = styled.span`
 text-decoration: underline;
 color: var(--primary);
 cursor: pointer;
`;

const RowBase = styled(GridBase)`
  border: 1px solid var(--border);
  border-radius: 6px;
  border-bottom: 4px double var(--border);
  background-color: var(--defaultTableCell);
`;

const Rows = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;

const HeaderCell = styled.div`
  font-weight: bold;
  padding: 15px;
  border-radius: 6px;
  color: var(--defaultTableCellTitle);
  background-color: var(--defaultTableCell);
  font-size: 0.875rem;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
`;

const TableCell = styled.div`
  margin: 0;
  text-align: left;
  padding: 18px 16px;
  border-bottom: 1px solid var(--border);
  overflow: auto;
  color: var(--mainText);
  font-size: 0.875rem;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
`;

const Center = styled.div`
  width: 100%;
  text-align: center;
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;
